// extracted by mini-css-extract-plugin
export default {"container":"lG-z","disabled":"mG-z","bgBlack":"nG-z","content":"oG-z","countdown":"pG-z","topCaption":"qG-z","topHeading":"rG-z","heading":"sG-z","copy":"tG-z"};